import { createSlice } from '@reduxjs/toolkit'
import { getServerConstants } from 'state/Constants'
import { useObjSelector } from 'utils'
import Reseller from './models/Reseller'

const slice = createSlice({
	name        : 'reseller',
	initialState: null, //= unsure
	reducers    : {
		setReseller  : (state, { payload: reseller }) => reseller,
		clearReseller: state => null,
	},
})

//not exactly official, but enough for some organization
slice.thunks = {}

export const getReseller    = ({ reseller }) => reseller? new Reseller(reseller) : null
export const useReseller    = () => useObjSelector(getReseller)
export const getHasReseller = ({ reseller }) => reseller !== false //null means "unsure", so let's play safe
export const getIsCMO       = state => state.reseller && getServerConstants(state).VALUES.RESELLER.CMO_IDS.includes(state.reseller.id)

export const getResellerStyle = state => getReseller(state)?.style
export const useResellerStyle = () => useObjSelector(getResellerStyle)

export const { setReseller, clearReseller } = slice.actions

export default slice.reducer
